export enum PromptShardType {
    TEXT, LORA
}
